const companyName = "Heron Lane Farm";
export { companyName };

const ogImagePath =
	"https://www.heronlanefarm.com/images/opengraphheronlane.jpg";
export { ogImagePath };

const canonicalUrl = "https://www.heronlanefarm.com/";
export { canonicalUrl };

const primaryEmail = "graceinsumas@gmail.com";
export { primaryEmail };
